import { gql } from '@apollo/client'

const RETRY_MENU_CURATION_TASK_AUTOMATIC_CURATION_MUTATION = gql`
  mutation retryMenuCurationTaskAutomaticCuration($id: ID!) {
    retryMenuCurationTaskAutomaticCuration(id: $id)
  }
`

export default RETRY_MENU_CURATION_TASK_AUTOMATIC_CURATION_MUTATION
